export const FEATURES_INFO = {
  view_shifts: {
    title: 'View Shifts',
    description: 'Watch over, monitor, and generate reports for your associates’ shifts.',
    icon: 'file',
    color: '#6C69FF',
    lightColor: '#D5D4FF'
  },
  manage_shifts: {
    title: 'Manage Shifts',
    description: 'Track, create, adjust, complete, or delete your associates’ shifts.',
    icon: 'file',
    color: '#6C69FF',
    lightColor: '#D5D4FF'
  },
  document: {
    title: 'Documents',
    description:
      'Create documents and send them for signature. Add processes like Onboarding, Training, and Departure.',
    icon: 'folder',
    color: '#3b82f6',
    lightColor: '#d4efff'
  },
  payment: {
    title: 'Payments',
    description:
      'Pay your Associates by tracking their invoices. This feature allows adding various payment systems and managing payment data and statistics.',
    icon: 'credit-card',
    color: '#10b981',
    lightColor: '#dbffbf'
  },
  scheduler: {
    title: 'Schedule',
    description: 'Plan shifts for your associates and notify them of changes in their work schedules.',
    icon: 'calendar',
    color: '#6C69FF',
    lightColor: '#D5D4FF'
  },
  marketplace: {
    title: 'Marketplace',
    description:
      'Use your own and third-party workers for short-term shift-based work. Post shifts on the Marketplace, and workers will be able to apply for them.',
    icon: 'shop',
    color: '#d47aff',
    lightColor: '#f1d4ff'
  },
  chat: {
    title: 'Chat',
    description:
      'Allow all associates and administrators to communicate in a secure chat exclusively for your company.',
    icon: 'message',
    color: '#33dfcf',
    lightColor: '#bffffb'
  },
  authorization: {
    title: 'Violations',
    description:
      'Track company policy violations that occur during shifts and review whether supervisor or admin approval was obtained.',
    icon: 'warning',
    color: '#f59e0b',
    lightColor: '#ffe4bb'
  },
  work_area: {
    title: 'Work Areas',
    description: 'Track the locations of your Associates to ensure they are not working outside designated work zones.',
    icon: 'environment',
    color: '#21E29D',
    lightColor: '#BFFFE8'
  },
  task: {
    title: 'Tasks',
    description:
      'Adds the ability for Associates to track their work tasks. You will be able to assign, track, and pay for tasks.',
    icon: 'bars',
    color: '#d47aff',
    lightColor: '#f1d4ff'
  },
  time_off: {
    title: 'Time Off',
    description: 'Associates will be able to submit requests for Vacation or report Sick.',
    icon: 'home',
    color: '#3b82f6',
    lightColor: '#d4efff'
  },
  shift_confirmation: {
    title: 'Digital CDPH 530',
    description:
      "The associate has to fill out the Digital CDPH-530 and find a supervisor to get it signed. This way, it'll be ready for pay.",
    icon: 'file-done',
    color: '#f59e0b',
    lightColor: '#ffe4bb'
  },
  req_manual_cdph_form: {
    title: 'Manual CDPH-530',
    description:
      "Associate must to complete the Manual CDPH-530 and attach it to the shift. This way, it'll be ready for pay. ",
    icon: 'file-done',
    color: '#f59e0b',
    lightColor: '#ffe4bb'
  },
  visitor: {
    title: 'Visitors',
    description:
      'Visitors are required to register upon arrival, providing necessary details for company access and tracking.',
    companyVisitorsText: 'Company Visitors',
    icon: 'usergroup-add',
    color: '#33dfcf',
    lightColor: '#bffffb'
  },
  mileage: {
    title: 'Mileage',
    description: 'Allows Associates to track their travel time, so you can monitor and compensate for mileage',
    icon: 'global',
    color: '#33dfcf',
    lightColor: '#bffffb'
  },
  sms: {
    title: 'SMS',
    description: 'Associates will receive SMS notifications while tracking shifts and when alerts are received.',
    icon: 'message',
    color: '#d47aff',
    lightColor: '#f1d4ff'
  },
  covid_survey: {
    title: 'COVID Survey',
    description: 'Associates are required to complete a COVID questionnaire before starting work.',
    icon: 'stop',
    color: '#3b82f6',
    lightColor: '#d4efff'
  },
  shift_processing_restriction: {
    title: 'Shift Processing Restriction',
    description:
      'Associates are allowed to modify or manually add shifts within a configurable time window, ensuring accurate scheduling and flexibility.',
    icon: 'stop',
    color: '#f59e0b',
    lightColor: '#ffe4bb'
  },
  onboarding: {
    title: 'Onboarding',
    description:
      'Automate the new hire onboarding process by collecting necessary documents from associates. Guide them to sign paperwork, watch orientation videos, and complete surveys before starting work.',
    icon: 'import',
    color: '#10b981',
    lightColor: '#dbffbf'
  },
  departure: {
    title: 'Departure',
    description:
      'Automate the associate offboarding process by collecting necessary documents from associates. Guide them to sign exit paperwork, watch departure videos, and complete surveys before leaving the company.',
    icon: 'export',
    color: '#f59e0b',
    lightColor: '#ffe4bb'
  },
  training: {
    title: 'Trainings',
    description:
      'Automate the professional development process by collecting necessary documents from associates. Guide them to sign paperwork, watch training videos, and complete surveys to enhance their skills and knowledge.',
    icon: 'reconciliation',
    color: '#21E29D',
    lightColor: '#BFFFE8'
  },
  point_system: {
    title: 'Rating System',
    description:
      'An intelligent performance evaluation system that analyzes every aspect of each employee’s work — from punctuality and rule compliance to productivity and overall contribution to the facility.',
    icon: 'crown',
    color: '#33dfcf',
    lightColor: '#bffffb'
  }
}

export const PROJECT_TEMPLATES = {
  all: {
    title: 'All',
    features: [
      'view_shifts',
      'manage_shifts',
      'document',
      'payment',
      'scheduler',
      'marketplace',
      'chat',
      'authorization',
      'work_area',
      'task',
      'time_off',
      'shift_confirmation',
      'visitor',
      'mileage',
      'sms',
      'covid_survey',
      'shift_processing_restriction',
      'onboarding',
      'departure',
      'training'
    ]
  },
  manage_documentation: {
    title: 'Manage Documentation',
    features: ['document', 'chat', 'onboarding', 'departure', 'training']
  },
  manage_agency: {
    title: 'Manage Legal Entity',
    features: ['document', 'payment', 'chat', 'onboarding', 'departure', 'training']
  },
  manage_facility: {
    title: 'Manage Facility',
    features: [
      'view_shifts',
      'manage_shifts',
      'document',
      'payment',
      'scheduler',
      'marketplace',
      'chat',
      'authorization',
      'work_area',
      'time_off',
      'shift_confirmation',
      'visitor',
      'shift_processing_restriction',
      'onboarding',
      'departure',
      'training'
    ]
  }
}

export const INITIAL_TIME_FORM = {
  before_shift_start_grace_period: 0,
  after_shift_start_grace_period: 0,
  before_shift_end_grace_period: 0,
  after_shift_end_grace_period: 0,
  missed_shift_duration: 0,
  shift_start_notification: 0,
  lunch_duration: 0,
  second_lunch_duration: 0,
  min_work_duration: 0,
  long_work_duration: 0,
  max_work_duration: 0,
  first_lunch_time: 0,
  min_work_with_waiver_duration: 0,
  long_work_with_waiver_duration: 0,
  signed_actual_time_discrepancy: 0,
  rest_breaks_period: 0,
  rest_break_duration: 0,
  shift_processing_duration: 0,
  scheduled_shift_notification: 0,
  outside_of_work_area_notification: 0,
  outside_of_work_area_complete_shift: 0,
  document_expiration_warning: 0,
  meal_grace_period: 0,
  short_shift_threshold: 0,
  vacation_lead_time: 0,
  sick_doctor_notice_threshold: 0
}

export const INITIAL_PAYMENT_FORM = {
  minimal_hour_rate: null,
  minimal_salary: null,
  instant_loan_percent: null,
  contractor_regular_hours: 0,
  contractor_overtime_hours: 0,
  contractor_double_time_hours: 0,
  contractor_regular_coefficient: 0,
  contractor_overtime_coefficient: 0,
  contractor_double_time_coefficient: 0,
  employee_regular_hours: 0,
  employee_overtime_hours: 0,
  employee_double_time_hours: 0,
  employee_regular_coefficient: 0,
  employee_overtime_coefficient: 0,
  employee_double_time_coefficient: 0,
  week_start: 0,
  specific_days: [],
  work_day_start: '08:00'
}

export const TIME_CATEGORIES = [
  {
    key: 'shift-management',
    title: 'Shift Management',
    fields: [
      {
        key: 'before_shift_start_grace_period',
        title: 'Before Start Grace Period',
        description:
          'The allowable buffer time before a scheduled shift begins during which a clock-in is still considered on time.'
      },
      {
        key: 'after_shift_start_grace_period',
        title: 'After Start Grace Period',
        description: 'The allowable buffer time after a scheduled shift begins before a late clock-in is flagged.'
      },
      {
        key: 'before_shift_end_grace_period',
        title: 'Before End Grace Period',
        description:
          'The allowable buffer time before a scheduled shift ends during which an early clock-out is still considered acceptable.'
      },
      {
        key: 'after_shift_end_grace_period',
        title: 'After End Grace Period',
        description:
          'The allowable buffer time after a scheduled shift ends during which a clock-out is still considered on time.'
      },
      {
        key: 'shift_processing_duration',
        title: 'Shift Processing Duration',
        description: 'Time window during which associates are allowed to make changes or manually create shifts.',
        in_days: true
      },
      {
        key: 'missed_shift_duration',
        title: 'Missed Shift Duration',
        description:
          'The minimum elapsed time from the scheduled shift start after which a shift is automatically marked as missed.'
      },
      {
        key: 'min_work_duration',
        title: 'Minimal Work Duration',
        description: 'The minimum shift duration that requires a first meal break.'
      },
      {
        key: 'long_work_duration',
        title: 'Long Work Duration',
        description: 'The minimum shift duration that requires a second meal break.'
      },
      {
        key: 'max_work_duration',
        title: 'Maximum Work Duration',
        description: 'The maximum continuous work duration permitted before a mandatory stop or break is required.'
      },
      {
        key: 'min_work_with_waiver_duration',
        title: 'Minimum Work with Waiver Duration',
        description:
          'The minimum work duration threshold below which an associate may waive their meal break entitlement.'
      },
      {
        key: 'long_work_with_waiver_duration',
        title: 'Long Work with Waiver Duration',
        description:
          'The extended work duration threshold below which an associate may waive their second meal break entitlement.'
      },
      {
        key: 'signed_actual_time_discrepancy',
        title: 'Adjust Tracked Time',
        description: 'Minimum time mismatch between signed and tracked time for creating a violation.'
      },
      {
        key: 'outside_of_work_area_complete_shift',
        title: 'Out-of-Zone Critical Limit',
        description:
          'The maximum elapsed time an associate may remain outside their designated work area before their active shift is automatically terminated.'
      },
      {
        key: 'short_shift_threshold',
        title: 'Short Shift Threshold',
        description: 'How much time must a worker be short on their shift to receive a Short Shift violation?'
      }
    ]
  },
  {
    key: 'notifications',
    title: 'Notifications',
    fields: [
      {
        key: 'scheduled_shift_notification',
        title: 'Scheduled Shift Notification',
        description: 'The advance notice period given to an associate when a shift is scheduled.',
        in_days: true
      },
      {
        key: 'shift_start_notification',
        title: 'Start Shift Notification',
        description: 'The advance notice period given to an associate before their shift is due to begin.'
      },
      {
        key: 'outside_of_work_area_notification',
        title: 'Out-of-Zone Warning',
        description:
          'The elapsed time an associate must spend outside their designated work area before a notification is triggered alerting them to return.'
      },
      {
        key: 'document_expiration_warning',
        title: 'Document Expiration Warning',
        description:
          "The advance notice period before a document's expiration date during which an associate is notified of the upcoming expiry.",
        in_days: true
      }
    ]
  },
  {
    key: 'time-off',
    title: 'Time Off',
    fields: [
      {
        key: 'vacation_lead_time',
        title: 'Vacation Lead Time',
        description: 'The minimum advance notice required before an associate can submit a Vacation request.',
        in_days: true
      },
      {
        key: 'sick_doctor_notice_threshold',
        title: 'Sick Doctor Notice Threshold',
        description: 'The number of Sick days at which an associate must provide a Doctor Notice.',
        in_days: true
      }
    ]
  },
  {
    key: 'meal-breaks',
    title: 'Meal Breaks',
    fields: [
      {
        key: 'first_lunch_time',
        title: '1st Meal Break Timing',
        description: 'The maximum duration from shift start within which the first meal break must be initiated.'
      },
      {
        key: 'second_lunch_duration',
        title: '2nd Meal Break Duration',
        description: 'The required duration of the second meal break during a shift, applicable for extended shifts.'
      },
      {
        key: 'lunch_duration',
        title: 'Meal Break Duration',
        description: 'The required duration of the first meal break during a shift.'
      },
      {
        key: 'meal_grace_period',
        title: 'Meal Grace Period',
        description:
          'The allowable buffer time around a meal break duration within which the break is still considered compliant with the required duration.'
      }
    ]
  },
  {
    key: 'rest-breaks',
    title: 'Rest Breaks',
    fields: [
      {
        key: 'rest_breaks_period',
        title: 'Rest Break Period',
        description: 'The maximum continuous work interval after which a mandatory rest break must be taken.'
      },
      {
        key: 'rest_break_duration',
        title: 'Rest Break Duration',
        description: 'The required duration of each rest break during a shift.'
      }
    ]
  }
]

export const PAYMENT_CATEGORIES = [
  {
    key: 'general',
    title: 'General',
    fields: [
      {
        key: 'minimal_hour_rate',
        title: 'Minimum Hourly Rate',
        description: 'The lowest permissible hourly pay rate that can be assigned to any associate.',
        type: 'number',
        min: 1,
        suffix: '$'
      },
      {
        key: 'minimal_salary',
        title: 'Minimum Salary',
        description: 'The lowest permissible salary that can be assigned to any associate.',
        type: 'number',
        min: 1,
        suffix: '$'
      },
      {
        key: 'week_start',
        title: 'Week Start',
        description: 'The day of the week on which the payroll and scheduling week begins.',
        type: 'select'
      },
      {
        key: 'work_day_start',
        title: 'Work Day Start',
        description: 'The time of day at which a work day begins for payroll calculation purposes.',
        type: 'time'
      },
      {
        key: 'specific_days',
        title: 'Specific Days',
        description: 'Days designated with custom pay rules or schedules that differ from the standard work week.',
        type: 'multi-select'
      }
    ]
  },
  {
    key: 'work-hours',
    title: 'Work Hours',
    fields: [
      {
        key: 'contractor_regular_hours',
        title: 'Regular Hours',
        description: 'The maximum number of daily hours counted as regular time before overtime rules apply.',
        type: 'number',
        min: 0,
        max: 24,
        suffix: 'h',
        isMinutes: true
      },
      {
        key: 'contractor_overtime_hours',
        title: 'Overtime Hours',
        description: 'The number of hours beyond Regular Hours that are compensated at the overtime rate.',
        type: 'number',
        min: 0,
        max: 24,
        suffix: 'h',
        isMinutes: true
      },
      {
        key: 'contractor_double_time_hours',
        title: 'Double Time Hours',
        description: 'The number of hours beyond Overtime Hours that are compensated at the double time rate.',
        type: 'number',
        min: 0,
        max: 24,
        suffix: 'h',
        isMinutes: true
      }
    ]
  },
  {
    key: 'contractor',
    title: 'Contractor',
    fields: [
      {
        key: 'contractor_regular_coefficient',
        title: 'Regular Rate Coefficient',
        description: "The pay rate multiplier applied to a contractor's regular hours.",
        type: 'number',
        min: 0,
        suffix: 'x'
      },
      {
        key: 'contractor_overtime_coefficient',
        title: 'Overtime Rate Coefficient',
        description: "The pay rate multiplier applied to a contractor's overtime hours.",
        type: 'number',
        min: 0,
        suffix: 'x'
      },
      {
        key: 'contractor_double_time_coefficient',
        title: 'Double Time Rate Coefficient',
        description: "The pay rate multiplier applied to a contractor's double time hours.",
        type: 'number',
        min: 0,
        suffix: 'x'
      }
    ]
  },
  {
    key: 'employee',
    title: 'Employee',
    fields: [
      {
        key: 'instant_loan_percent',
        title: 'Advance Percent',
        description: 'The maximum percentage of earned wages an employee may request as a pay advance.',
        type: 'number',
        min: 1,
        max: 100,
        suffix: '%',
        isPercent: true
      },
      {
        key: 'employee_regular_hours',
        title: 'Regular Hours',
        description:
          'The maximum number of daily hours counted as regular time for employees before overtime rules apply.',
        type: 'number',
        min: 0,
        max: 24,
        suffix: 'h',
        isMinutes: true
      },
      {
        key: 'employee_overtime_hours',
        title: 'Overtime Hours',
        description: 'The number of hours beyond Employee Regular Hours that are compensated at the overtime rate.',
        type: 'number',
        min: 0,
        max: 24,
        suffix: 'h',
        isMinutes: true
      },
      {
        key: 'employee_double_time_hours',
        title: 'Double Time Hours',
        description: 'The number of hours beyond Employee Overtime Hours that are compensated at the double time rate.',
        type: 'number',
        min: 0,
        max: 24,
        suffix: 'h',
        isMinutes: true
      },
      {
        key: 'employee_regular_coefficient',
        title: 'Regular Rate Coefficient',
        description: "The pay rate multiplier applied to an employee's regular hours.",
        type: 'number',
        min: 0,
        suffix: 'x'
      },
      {
        key: 'employee_overtime_coefficient',
        title: 'Overtime Rate Coefficient',
        description: "The pay rate multiplier applied to an employee's overtime hours.",
        type: 'number',
        min: 0,
        suffix: 'x'
      },
      {
        key: 'employee_double_time_coefficient',
        title: 'Double Time Rate Coefficient',
        description: "The pay rate multiplier applied to an employee's double time hours.",
        type: 'number',
        min: 0,
        suffix: 'x'
      }
    ]
  }
]
export const WEEK_DAYS = [
  { name: 'Sunday', id: 6 },
  { name: 'Monday', id: 0 },
  { name: 'Tuesday', id: 1 },
  { name: 'Wednesday', id: 2 },
  { name: 'Thursday', id: 3 },
  { name: 'Friday', id: 4 },
  { name: 'Saturday', id: 5 }
]
